import { QuestionBase } from '../question-types/question-base';

export class ExpandableQuestion<T> extends QuestionBase<T> {
  isExpanded: boolean;
  constructor(options: {} = {}, label: string = '') {
    super(options);
    this.isExpanded = false;
  }
}
